import { Box } from '@mui/material';
import changePasswordPlugin from 'common/plugins/change-password-plugin/changePasswordPluginCreator';
import verifySignupPlugin from 'common/plugins/verify-signup-plugin/verifySignupPluginCreator';
import { createBrowserHistory, type BrowserHistory } from 'history';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { RouterProvider } from 'react-router';

import Root from './Root';
import { router } from './Router';

const App = () => {
  const history: BrowserHistory = createBrowserHistory();
  const sessionPlugins = [
    changePasswordPlugin(history.location.hash),
    verifySignupPlugin(history.location.hash),
  ];

  const height = '100%';

  return (
    <>
      <style>
        {`
          body {
            height: ${height};
          }
          html {
            height: ${height};
          }
          #root {
            height: ${height};
          }
        `}
      </style>
      <Box sx={{ minHeight: '100svh', height }}>
        <Root sessionPlugins={sessionPlugins}>
          <NuqsAdapter>
            <RouterProvider router={router} />
          </NuqsAdapter>
        </Root>
      </Box>
    </>
  );
};

export default App;
